import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Header from './components/Header/index';
import History from './components/History';
import Products from './components/Products';
import Stats from './components/Stats';
import { TPreparedContentBlocks } from './helpers';

import * as ST from './styled';

interface IProps {
    stats: TPreparedContentBlocks[],
    history: TPreparedContentBlocks[],
}

const About = ({ stats, history }: IProps) => {
    const showStats = stats.length > 0;
    const showHistory = history.length > 0;

    return (
        <>
            <Header />
            {(showStats || showHistory) && <ST.Wrapper indent={{ $mobile: [20, 0, 0], $desktop: [24, 0, 0] }} rounder={{ $radius: 32 }} bgColor={COLORS.BgMain}>
                <WideContainer>
                    {showStats && <Stats stats={stats} />}
                    {showHistory && <History history={history} />}
                </WideContainer>
            </ST.Wrapper>}
            <Products hasNegativeMarginTop={!showStats && !showHistory} />
        </>
    );
};

export default About;
